module.exports = __webpack_public_path__ + "static/contenu-ff269f919f879ada3ab61446d5b61ace.jpg";